var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4901 0.854878L40.4211 4.30366C45.187 5.5748 47.1051 9.01617 45.844 13.7002L41.5735 29.5644C40.752 32.6162 39.071 34.5189 36.7146 35.1569C36.8072 34.5178 36.8548 33.8521 36.8548 33.1623V18.2169C36.8548 11.7411 32.683 7.38743 26.4527 7.38743H17.7773L18.0719 6.29318C19.3328 1.60918 22.7997 -0.396085 27.4901 0.854878Z",
    fill: "url(#paint0_linear_2916_19487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6808 7.15625H26.6727C29.745 7.15625 32.2945 8.23347 34.0764 10.0985C35.8591 11.9644 36.8898 14.6362 36.8898 17.8529V32.9226C36.8898 36.13 35.8592 38.7971 34.0765 40.6608C32.2945 42.5236 29.745 43.6007 26.6727 43.6007H10.6808C7.60845 43.6007 5.05421 42.5236 3.26765 40.6606C1.4803 38.7968 0.445312 36.1297 0.445312 32.9226V17.8529C0.445312 14.6364 1.4804 11.9648 3.26774 10.0987C5.0543 8.23352 7.60845 7.15625 10.6808 7.15625Z",
    fill: "url(#paint1_linear_2916_19487)",
    stroke: "url(#paint2_linear_2916_19487)",
    strokeWidth: 0.444444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2916_19487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2565 34.448C37.3077 33.9638 37.3338 33.4653 37.3338 32.9535V17.9951C37.3338 11.5138 33.1711 7.15625 26.9546 7.15625H18.4811L14.5956 21.6345C13.3335 26.3371 15.3145 29.6961 19.9333 30.9318L32.6672 34.3385C34.3941 34.8005 35.9353 34.8298 37.2565 34.448Z",
    fill: "url(#paint3_linear_2916_19487)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6905 31.6016C16.2752 31.6016 15.8599 31.4445 15.5429 31.1287L11.1435 26.7454C10.5094 26.1137 10.5094 25.0904 11.1435 24.4605C11.7776 23.8288 12.8028 23.8269 13.4368 24.4586L16.6905 27.7004L24.3436 20.0753C24.9776 19.4436 26.0028 19.4436 26.6368 20.0753C27.2709 20.7071 27.2709 21.7304 26.6368 22.3621L17.8381 31.1287C17.521 31.4445 17.1058 31.6016 16.6905 31.6016Z",
    fill: "url(#paint4_linear_2916_19487)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2916_19487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 19,
    width: 18,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6905 31.6016C16.2752 31.6016 15.8599 31.4445 15.5429 31.1287L11.1435 26.7454C10.5094 26.1137 10.5094 25.0904 11.1435 24.4605C11.7776 23.8288 12.8028 23.8269 13.4368 24.4586L16.6905 27.7004L24.3436 20.0753C24.9776 19.4436 26.0028 19.4436 26.6368 20.0753C27.2709 20.7071 27.2709 21.7304 26.6368 22.3621L17.8381 31.1287C17.521 31.4445 17.1058 31.6016 16.6905 31.6016Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2916_19487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.668 27.7611L16.6052 27.824L16.668 27.8865L16.7307 27.824L16.668 27.7611ZM16.8902 31.4751C16.4574 31.4751 16.0251 31.3695 15.6951 31.1571L15.5569 31.2467C15.9253 31.4838 16.408 31.6016 16.8902 31.6016V31.4751ZM15.5569 31.033L11.2356 26.7127L11.1124 26.8368L15.4336 31.1571L15.5569 31.033ZM11.1124 26.5966C10.6877 26.0463 10.6878 25.1552 11.1124 24.6067L11.0236 24.4905C10.5494 25.1031 10.5495 26.0984 11.0235 26.7127L11.1124 26.5966ZM11.2277 24.4905C11.7785 24.0668 12.6688 24.0657 13.2194 24.4891L13.3346 24.3998C12.7201 23.9271 11.7267 23.9286 11.1124 24.4011L11.2277 24.4905ZM13.3346 24.6068L16.7582 27.6016L16.8902 27.4852L13.4667 24.4905L13.3346 24.6068ZM16.5676 27.6016L24.0013 20.1687L23.8794 20.046L16.4457 27.4788L16.5676 27.6016ZM24.1166 20.046C24.6672 19.6218 25.5576 19.6218 26.1083 20.046L26.2235 19.9566C25.6092 19.4832 24.6157 19.4832 24.0013 19.9566L24.1166 20.046ZM26.668 20.162C27.0926 20.7118 27.0926 21.6024 26.668 22.1523L26.7569 22.2682C27.2309 21.6544 27.2309 20.6598 26.7569 20.046L26.668 20.162ZM26.543 22.2682L17.7791 31.0313L17.904 31.1571L26.668 22.3941L26.543 22.2682ZM18.0853 31.1571C17.7553 31.3695 17.323 31.4751 16.8902 31.4751V31.6016C17.3724 31.6016 17.8551 31.4838 18.2235 31.2467L18.0853 31.1571Z",
    fill: "url(#paint5_linear_2916_19487)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2916_19487",
    x: 7.11155,
    y: 0.0451388,
    width: 37.3316,
    height: 41.7769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55556,
    result: "effect1_foregroundBlur_2916_19487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2916_19487",
    x1: 2523.2,
    y1: 583.725,
    x2: 184.624,
    y2: 2215.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2828FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1515A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2916_19487",
    x1: 3678.4,
    y1: -26.3557,
    x2: -21.8454,
    y2: 3673.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CF5",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2916_19487",
    x1: 565.388,
    y1: 414.644,
    x2: 2918.59,
    y2: 3329.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2916_19487",
    x1: 2089.34,
    y1: 470.754,
    x2: 163.321,
    y2: 1852.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2916_19487",
    x1: 1538.52,
    y1: 415.491,
    x2: -289.822,
    y2: 497.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2916_19487",
    x1: 194.708,
    y1: 515.989,
    x2: 1576.06,
    y2: 526.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/Applications.491e1845daff3542380a48daf28d9a63.svg";
export { ForwardRef as ReactComponent };